import React, { useState } from 'react';
import { EventCard } from './EventCard';
import { NewsCard } from './NewsCard';
import { SocialCard } from './SocialCard';
import { PersonalizeModal } from './PersonalizeModal';
import { UserIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const ContentFeed = () => {
  const navigate = useNavigate();
  const [personalizeModalOpen, setPersonalizeModalOpen] = useState(false);
  const handleOpenPersonalizeModal = () => {
    navigate('/app/personalize');
  };
  const handleClosePersonalizeModal = () => {
    setPersonalizeModalOpen(false);
  };
  const handleOptionSelect = (option: string) => {
    console.log('Selected option:', option);
    setPersonalizeModalOpen(false);
  };
  return <div className="p-6" data-id="element-20">
      {/* Personalization Banner */}
      <div className="mb-8 bg-gradient-to-r from-[#2C3E50] to-[#4A5568] rounded-xl overflow-hidden shadow-lg" data-id="element-21">
        <div className="p-6 flex flex-col items-center" data-id="element-22">
          <div className="mb-6 text-center" data-id="element-23">
            <h2 className="text-2xl font-bold text-[#F5F5F7] mb-2" data-id="element-24">
              Hey, Stranger!
            </h2>
            <p className="text-gray-300" data-id="element-25">
              Let's get to know each other better now, so that I can dial in my
              recommendations.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 justify-center" data-id="element-26">
            <button onClick={handleOpenPersonalizeModal} className="bg-gradient-to-r from-sky-500 to-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:from-sky-600 hover:to-blue-700 transition-colors flex items-center whitespace-nowrap" data-id="element-27">
              <UserIcon size={20} className="mr-2" data-id="element-28" />
              Let's do this!
            </button>
          </div>
        </div>
      </div>
      <h1 className="text-3xl font-bold text-[#F5F5F7] mb-6" data-id="element-29">For You</h1>
      <div className="mb-8" data-id="element-30">
        <h2 className="text-xl font-semibold text-[#F5F5F7] mb-4" data-id="element-31">
          Upcoming Events
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-32">
          <EventCard title="Lakers vs. Warriors" date="Fri, Nov 10 • 7:30 PM" location="Crypto.com Arena, Los Angeles" imageUrl="https://images.unsplash.com/photo-1504450758481-7338eba7524a?q=80&w=2069&auto=format&fit=crop" friendsGoing={3} friendsInterested={7} category="NBA" recommendationReason="You'd never miss it" data-id="element-33" />
          <EventCard title="Taylor Swift: The Eras Tour" date="Sat, Nov 25 • 8:00 PM" location="SoFi Stadium, Los Angeles" imageUrl="https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?q=80&w=2070&auto=format&fit=crop" friendsGoing={2} category="Concert" recommendationReason="Biggest act this century" data-id="element-34" />
          <EventCard title="LA Art Show 2025" date="Thu, Dec 5 - Sun, Dec 8" location="Los Angeles Convention Center" imageUrl="https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?q=80&w=2080&auto=format&fit=crop" category="Art" recommendationReason={['Looks like your vibe', 'Your calendar is free']} data-id="element-35" />
        </div>
      </div>
      <div className="mb-8" data-id="element-36">
        <h2 className="text-xl font-semibold text-[#F5F5F7] mb-4" data-id="element-37">
          Latest Updates
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-38">
          <NewsCard title="LeBron James Breaks Another NBA Record" source="Sports Center" excerpt="Lakers star LeBron James made history last night by becoming the first player to..." imageUrl="https://images.unsplash.com/photo-1596492784531-6e6eb5ea9993?q=80&w=1974&auto=format&fit=crop" category="NBA" data-id="element-39" />
          <NewsCard title="Taylor Swift Announces New Album Release Date" source="Music Today" excerpt="Pop superstar Taylor Swift has officially announced her next studio album will be released on..." category="Music" data-id="element-40" />
        </div>
      </div>
      <div data-id="element-41">
        <h2 className="text-xl font-semibold text-[#F5F5F7] mb-4" data-id="element-42">
          Social Planning
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-43">
          <SocialCard title="Plan a group outing" description="Create a plan with friends to attend this upcoming Lakers game together." eventName="Lakers vs. Warriors" eventDate="Fri, Nov 10 • 7:30 PM" data-id="element-44" />
          <SocialCard title="Find concert buddies" description="See which of your friends might want to join you at Taylor Swift's concert." eventName="Taylor Swift: The Eras Tour" eventDate="Sat, Nov 25 • 8:00 PM" data-id="element-45" />
        </div>
      </div>
      <PersonalizeModal isOpen={personalizeModalOpen} onClose={handleClosePersonalizeModal} onOptionSelect={handleOptionSelect} data-id="element-46" />
    </div>;
};